import { render } from "./Relationship.vue?vue&type=template&id=042b559c&scoped=true"
import script from "./Relationship.vue?vue&type=script&lang=js"
export * from "./Relationship.vue?vue&type=script&lang=js"

import "./Relationship.vue?vue&type=style&index=0&id=042b559c&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042b559c"]])

export default __exports__